import React, { useState, useEffect } from "react";
import "./App.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaBars,
  FaTimes,
  FaBaby,
  FaHeartbeat,
  FaUserMd,
  FaStethoscope,
  FaFlask,
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";

const slides = [
  {
    title: "Coloring",
    heading: "Nurturing Your Precious Miracles  Care",
    desc: "We blend advanced medical care with heartfelt compassion, ensuring the best treatment for every mother and child.",
    image: "/ashtavinayakhospital_baby1.png",
    gradient: "linear-gradient(135deg, #00a3c8 0%, #0277a6 100%)",
  },
  {
    title: "Dedicated Care",
    heading: "Advanced Pediatric & Neonatal Care",
    desc: "Providing expert care and state-of-the-art facilities for your little one’s health and growth.",
    image: "/ashtavinayakhospital_baby2.png",
    gradient: "linear-gradient(135deg, #0091b8 0%, #005f8a 100%)",
  },
  {
    title: "Trusted by Families",
    heading: "Your Health, Our Priority Always",
    desc: "With compassion and expertise, we care for mothers and children every step of the way.",
    image: "/ashtavinayakhospital_baby3.png",
    gradient: "linear-gradient(135deg, #008bb5 0%, #026b9b 100%)",
  },
];

const Home = () => {
  const [current, setCurrent] = useState(0);
  const [animate, setAnimate] = useState(true);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Hero auto-slide
  useEffect(() => {
    const timer = setInterval(() => {
      setAnimate(false);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % slides.length);
        setAnimate(true);
      }, 100);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  // Scroll header effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Prevent body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  // Split text animation
  const splitLetters = (text) =>
  text.split("").map((char, i) => (
    <span
      key={i}
      style={{ "--i": i }}
      className={char === " " ? "space" : ""}
    >
      {char}
    </span>
  ));


  return (
    
      <div className="home-page">
  <Helmet>
    <title>Ashtavinayak Children's Hospital & Critical Care | Sambhajinagar</title>
    <meta
      name="description"
      content="Ashtavinayak Children's Hospital & Critical Care, Sambhajinagar — advanced pediatric, neonatal, and maternity care with expert doctors and 24/7 emergency support."
    />
    <meta
      name="keywords"
      content="Ashtavinayak Hospital, Children's Hospital Sambhajinagar, Pediatric Care, Neonatal ICU, PICU, Maternity Hospital, Women's Health, 24x7 Emergency Care"
    />
    <meta name="author" content="Ashtavinayak Children's Hospital & Critical Care" />

    {/* ✅ Open Graph / Facebook */}
    <meta property="og:title" content="Ashtavinayak Children's Hospital & Critical Care" />
    <meta property="og:description" content="Trusted pediatric and maternity hospital in Sambhajinagar providing NICU, PICU, and emergency care services." />
    <meta property="og:image" content="/logo.png" />
    <meta property="og:url" content="https://www.ashtavinayakhospital.in" />
    <meta property="og:type" content="website" />

    {/* ✅ Twitter Card */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Ashtavinayak Children's Hospital & Critical Care" />
    <meta name="twitter:description" content="Caring for mothers, children, and families with compassion and advanced medical expertise." />
    <meta name="twitter:image" content="/logo.png" />

    {/* ✅ Favicon + App Metadata */}
    <link rel="icon" href="/favicon.ico" />
    <meta name="theme-color" content="#0091b8" />
  </Helmet>

      {/* ===== Transparent Gradient Navbar ===== */}
      <header
        className={`main-header ${isScrolled ? "scrolled" : ""}`}
        style={{
          zIndex: 5000,
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
        }}
      >
        <div className="navbar-container">
          {/* Logo */}
          <a href="/" className="navbar-logo">
            <img
              src="/logo.png"
              alt="Ashtavinayak Children's Hospital & Critical Care logo"
            />
          </a>

          {/* Navigation Links on Right */}
          <nav
            className={`nav-links ${menuOpen ? "active" : ""}`}
            style={{
              zIndex: 6000,
              position: menuOpen ? "fixed" : "",
            }}
          >
            <a href="/" onClick={() => setMenuOpen(false)}>
              Home
            </a>
            <a href="/about" onClick={() => setMenuOpen(false)}>
              About Us
            </a>
            <a href="/facilities" onClick={() => setMenuOpen(false)}>
              Facilities
            </a>
            <a href="/contact" onClick={() => setMenuOpen(false)}>
              Contact
            </a>
          </nav>

          {/* Hamburger Icon */}
          <button
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle Menu"
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>

      {/* ===== Hero Section ===== */}
      <section
        className={`hero-section ${animate ? "animate-layers" : ""}`}
        style={{ background: slides[current].gradient }}
      >
        <div className="hero-layer layer-1"></div>
        <div className="hero-layer layer-2"></div>
        <div className="hero-layer layer-3"></div>
        <div className="hero-layer layer-4"></div>

       <div className={`hero-content ${animate ? "active" : ""}`}>

          <h4>{splitLetters(slides[current].title)}</h4>
          <h1>{splitLetters(slides[current].heading)}</h1>
          <p>{splitLetters(slides[current].desc)}</p>
        </div>

        <div className="hero-image slide-in">
          <img src={slides[current].image} alt="Ashtavinayak Hospital" />
        </div>

        <div className="carousel-dots">
          {slides.map((_, i) => (
            <span
              key={i}
              className={i === current ? "dot active" : "dot"}
              onClick={() => setCurrent(i)}
            ></span>
          ))}
        </div>
      </section>

      {/* ===== Wellness Section ===== */}
      <section className="wellness-section">
        <div className="container text-center">
          <h2 className="section-title">A World of Wellness For Your Little Ones</h2>
          <p className="section-subtitle">
            We’re dedicated to providing a wide range of services tailored to the
            unique needs of mothers, children, and women.
          </p>

          <div className="vertical-cards">
            <div className="service-card">
              <FaBaby className="service-icon" />
              <h4>Neonatal Intensive Care Unit (NICU)</h4>
              <p>
                Our state-of-the-art NICU offers specialized care for premature and
                critically ill newborns. Equipped with advanced technology and expert
                neonatologists, our NICU ensures the best possible outcomes for the
                most vulnerable infants.
              </p>
            </div>

            <div className="service-card">
              <FaHeartbeat className="service-icon" />
              <h4>Pediatric Intensive Care Unit (PICU)</h4>
              <p>
                Our PICU provides expert care for critically ill children, focusing
                on complex medical conditions. Our specialized pediatric team uses
                the latest technology and treatment protocols to support recovery and
                well-being.
              </p>
            </div>

            <div className="service-card">
              <FaUserMd className="service-icon" />
              <h4>Newborn Screening and Vaccinations</h4>
              <p>
                Our comprehensive newborn screening identifies potential health
                issues early, ensuring timely intervention. We also offer a full
                range of vaccinations to protect your baby and support long-term
                health.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* ===== Trust Section ===== */}
<section className="trust-section">
  <div className="trust-container">
    {/* Left Image */}
    <div className="trust-image">
      <img src="/ashtavinayakhospital_homebg.png" alt="Trusted Care" />
    </div>

    {/* Right Content */}
    <div className="trust-content">
      <h2 className="trust-title">
        Here’s Why You Can Trust Us with Your Loved Ones
      </h2>

      <div className="trust-points">
        <div className="trust-point">
          <div className="trust-icon-circle teal">
            <FaHeartbeat className="trust-icon" />
          </div>
          <div>
            <h4>Patient-Centric Approach</h4>
            <p>
              We center our work on our patients' needs and emotions,
              ensuring that every mother and child feels cared for.
            </p>
          </div>
        </div>

        <div className="trust-point">
          <div className="trust-icon-circle blue">
            <FaUserMd className="trust-icon" />
          </div>
          <div>
            <h4>Comprehensive Care</h4>
            <p>
              From pregnancy and childbirth to pediatric care and women’s
              health, we offer holistic medical services for the entire family.
            </p>
          </div>
        </div>

        <div className="trust-point">
          <div className="trust-icon-circle teal">
            <FaBaby className="trust-icon" />
          </div>
          <div>
            <h4>Advanced Medical Technology</h4>
            <p>
              Our hospital has the latest medical equipment, ensuring the best
              possible outcomes for all patients.
            </p>
          </div>
        </div>

        <div className="trust-point">
          <div className="trust-icon-circle blue">
            <FaHeartbeat className="trust-icon" />
          </div>
          <div>
            <h4>Comfort and Compassion</h4>
            <p>
              We go beyond just medical care by offering a comfortable and caring
              environment for families.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="doctors-section">
  <h2 class="doctors-title">Meet Our Doctors</h2>
  <div class="doctors-wrapper">
    
    <div class="doctor-card">
      <div class="doctor-image">
        <img src="/ashtavinayakhospital_dr.Avinash.jpeg" alt="Dr. Avinash A Shelke" />
      </div>
      <h4>DR. AVINASH A SHELKE</h4>
      <p>Director, Pedicician and pediatric intensivist </p>
      <p>M.B.B.S. DCH</p>
    </div>

    <div class="doctor-card">
      <div class="doctor-image">
        <img src="/ashtavinayakhospital_dr.Pooja.jpeg" alt="Dr.pooja dilip gore" />
      </div>
      <h4>Dr. POOJA DILIP GORE</h4>
      
      <p>Cosmetologist and dermatologist</p>
      <p>BAMS</p>
    </div>

    <div class="doctor-card">
      <div class="doctor-image">
        <img src="/ashtavinayakhospital_doctorprofile.png" alt="Dr. Dipak Marakwad " />
      </div>
      <h4>DR. DIPAK MARAKWAD</h4>
      
      <p>MD ( Ped) , FPC ( Wadia Hosp ) , PCICU ( UK ) , Fetal echo cert ( UAE )</p>
    </div>
  </div>
</section>
<section className="visiting-doctors-section">
  <h2 className="doctors-title">Our Visiting Specialists</h2>
  <p className="doctors-subtitle">
    Highly qualified specialists offering advanced pediatric expertise — ensuring the best care for your child’s unique needs.
  </p>

  <div className="doctors-wrapper">
    {/* Doctor 1 */}
    <div className="doctor-card">
      <div className="doctor-image">
        <img src="/ashtavinayakhospital_doctorprofile.png" alt="Dr. Sandeep Saraf" />
      </div>
      <h4>Dr. SANDEEP SARAF SIR</h4>
      <p>Pediatric neurologist</p>
    </div>

    {/* Doctor 2 */}
    <div className="doctor-card">
      <div className="doctor-image">
        <img src="/ashtavinayakhospital_femaleprofile.png" alt="Dr. Sandhya Kondapalle" />
      </div>
      <h4>Dr. SANDHYA KONDAPALLE MAM</h4>
      <p>Pediatric endocrinologist</p>
    </div>

    {/* Doctor 3 */}
    <div className="doctor-card">
      <div className="doctor-image">
        <img src="/ashtavinayakhospital_doctorprofile.png" alt="Dr. Sandeep Sisode" />
      </div>
      <h4>Dr. SANDEEP SISODE SIR</h4>
      <p>Pediatric psycologist</p>
    </div>

    {/* Doctor 4 */}
    <div className="doctor-card">
      <div className="doctor-image">
        <img src="/ashtavinayakhospital_doctorprofile.png" alt="Dr. Quazi" />
      </div>
      <h4>Dr. QUAZI SIR</h4>
      <p>General and laproscopy surgeons</p>
    </div>
  </div>
</section>

{/* <section className="appointment-section">
  <div className="appointment-container">
    <div className="appointment-text">
      <h2>
        A Spectrum of Care for <br />
        <span>Every Stage of Childhood and Motherhood</span>
      </h2>
      <h3>Pediatric & Neonatal Care</h3>
      <p>
        Ashtavinayak Children's Hospital & Critical Care is Sambhajinagar’s trusted
        destination for pediatric and maternity care. Our team of expert doctors
        and compassionate nurses ensures the best care for every child and
        mother — combining advanced medical technology with personal attention.
      </p>

      <div className="appointment-highlight">
        <h4>Need Emergency Help?</h4>
        <a href="tel:+919876543210" className="emergency-call">
          <i className="fas fa-phone-alt"></i> Call Now
        </a>
      </div>
    </div>
  </div>
</section> */}
<section className="emergency-section">
  <div className="emergency-overlay"></div>
  <div className="emergency-container">
    {/* LEFT TEXT SIDE */}
    <div className="emergency-text">
      <div className="icon-row">
        <FaHeartbeat className="clock-icon" />
        <h2>
          Emergency <br />
          <span>Medical Care 24/7</span>
        </h2>
      </div>
      <p>
        With round-the-clock emergency assistance, you can rely on our expert doctors and advanced facilities — always ready when it matters most.
      </p>

      <div className="call-box">
  <FaPhoneAlt className="call-icon" />
  <a href="tel:+918149492473" className="call-number">
    +91 8149492473
  </a>
</div>

    </div>

    {/* RIGHT IMAGE SIDE */}
    <div className="emergency-image">
      <img src="/ashtavinayakhospital_baby.png" alt="Emergency Doctor" />
    </div>
  </div>
</section>

<section className="deliver-section">
  <div className="container text-center">
    <h2 className="section-title">What We Deliver</h2>
    <p className="section-subtitle">
      Our hospital is equipped with the latest medical technology and
      comfort-focused amenities to provide a welcoming environment for our patients.
    </p>

    <div className="vertical-cards">
      <div className="service-card">
        <FaBaby className="service-icon" />
        <h4>Advanced Neonatology Intensive Care Unit (NICU)</h4>
        <p>
          Featuring the latest in neonatal care technology for premature and
          critically ill babies, our NICU ensures specialized care and support for
          fragile newborns.
        </p>
      </div>

      <div className="service-card">
        <FaHeartbeat className="service-icon" />
        <h4>Pediatric Intensive Care Unit (PICU)</h4>
        <p>
          Our PICU provides expert medical care for critically ill children, equipped
          with cutting-edge technology and a dedicated team of pediatric specialists.
        </p>
      </div>

      <div className="service-card">
        <FaPhoneAlt className="service-icon" />
        <h4>24/7 Emergency Care</h4>
        <p>
          Round-the-clock emergency care services for women and children, ensuring
          immediate medical attention with a team ready to handle critical situations
          anytime.
        </p>
      </div>

     <div className="service-card">
        <FaUserMd className="service-icon" />
        <h4>Comfortable Family Spaces</h4>
        <p>
          Spacious, hygienic, and welcoming patient rooms designed for family comfort —
          ensuring a healing environment that feels just like home.
        </p>
      </div>

      <div className="service-card">
        <FaStethoscope className="service-icon" />
        <h4>Modern Infrastructure & Facilities</h4>
        <p>
          Our premises feature modern interiors, digital monitoring systems, and
          child-friendly designs — combining safety with convenience.
        </p>
      </div>

      <div className="service-card">
        <FaFlask className="service-icon" />
        <h4>In-House Laboratory and Diagnostic Services</h4>
        <p>
          Comprehensive in-house lab and diagnostic services provide fast, accurate
          results for timely diagnosis, ensuring convenience and seamless treatment
          for all patients.
        </p>
      </div>
    </div>
  </div>
</section>
{/* ===== Map Section ===== */}
<section className="map-section">
  <h2 className="map-title">Find Us Easily</h2>
  <p className="map-subtitle">
    Visit us at Ashtavinayak Children's Hospital & Critical Care , Sambhajinagar — providing comfort and care every step of the way.
  </p>
  <div className="map-container">
    <iframe
      title="Ashtavinayak Children's Hospital & Critical Care  Location"
     src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25057.47663987742!2d75.31093861083981!3d19.85019790000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdba279f42c1a5b%3A0x36f898a78dd629a4!2sSavitri%20Lawns!5e1!3m2!1sen!2sin!4v1761809239659!5m2!1sen!2sin" width="100%"
      height="450"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
    ></iframe>
    </div>
</section>
 <a href="tel:+918149492473" className="sticky-call-btn">
        <FaPhoneAlt className="call-icon" />
        <span>Call Us Now</span>
      </a>
{/* ===== Footer Section ===== */}
<footer className="footer-section">
  <div className="footer-container">
    {/* === LEFT ABOUT SECTION === */}
    <div className="footer-about">
      <img
        src="/logo.png"
        alt="Ashtavinayak Children's Hospital & Critical Care"
        className="footer-logo"
      />
      <p>
        Ashtavinayak Children's Hospital & Critical Care is dedicated to
                   providing comprehensive medical care for children.
      </p>
    </div>

    {/* === CENTER QUICK LINKS === */}
    <div className="footer-links">
      <h4>Quick Links</h4>
      <ul>
        <li><a href="/">Home</a></li>
        <li><a href="/about">About Us</a></li>
        <li><a href="/facilities">Facilities</a></li>
        <li><a href="/contact">Contact</a></li>
      </ul>
    </div>

    {/* === RIGHT CONTACT SECTION === */}
    <div className="footer-contact">
      <h4>Contact Us</h4>
      <p> Ashtvinayak hospital, KT complex, beside savitri lawns, Sambhajinagar, India-431002     </p>
      <p>
        <a href="tel:+918149492473" className="contact-link">
          <FaPhoneAlt /> +91 8149492473
        </a>
      </p>
      <p>
        <a
          href="mailto:ashtavinayakhospital@gmail.com"
          className="contact-link"
        >
          <FaEnvelope /> ashtavinayakhospital@gmail.com
        </a>
      </p>
    </div>
  </div>

  {/* === FOOTER BOTTOM === */}
  <div className="footer-bottom">
    <p>
      © {new Date().getFullYear()} Ashtavinayak Children's Hospital & Critical
      Care. All Rights Reserved.
      <br />
      <span className="developer-text">
        Designed & Developed by{" "}
        <a
          href="https://intelligicsoftware.in"
          target="_blank"
          rel="noopener noreferrer"
        >
          Intellgic Software Pvt. Ltd.
        </a>
      </span>
    </p>
  </div>
</footer>


    </div>
  );
};

export default Home;
